import React from "react";
import Typography from "@material-ui/core/Typography";
import {
  CardContent,
  Divider,
  TextField,
  Chip,
  IconButton,
  Tooltip,
  InputBase,
  Paper,
  Grid,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import NotesIcon from "@material-ui/icons/Notes";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import { fbdb } from "../AppClass";
import { LinearProgress, DialogContent } from "@material-ui/core/es";

import { FetchData } from "../services/FetchData";
import { AppContext } from "../App";

import ReactContentEditable from "./react-simple-contenteditable";

class MyNotes extends React.Component {
  state = {
    notes: [],
    notes_fetching: false,

    timestamp: new Date().getTime(),
    skip_note: 0,

    dialogOpen: false,

    dialog_id: "",
    dialog_note_key: "",
    dialog_note_text: ""
  };

  componentDidMount() {}

  //saved_notes = [];
  getSavedNotes = load_type => {
    this.setState({ notes_fetching: true });
    let saved_notes = [];

    let self = this;
    const auth_token = localStorage.getItem("auth_token");

    //var docRef = fbdb.collection(auth_token).doc("bRt3oKyueSq1YCQPTHAe")

    //offline
    var getOptions = {
      source: "cache"
    };

    // docRef.get(/*getOptions*/).then(function(doc) {
    //     if (doc.exists) {
    //         console.log("Document data:", doc.data());
    //     } else {
    //         // doc.data() will be undefined in this case
    //         console.log("No such document!");
    //     }
    // }).catch(function(error) {
    //     console.log("Error getting document:", error);
    // });

    //let saved_notes = [];
    // fbdb
    //   .collection(auth_token)
    //   .where("time", "<", this.state.timestamp)
    //   .orderBy("time", "desc")
    //   .limit(6)
    //   .get()
    //   .then(function(querySnapshot) {
    //     querySnapshot.forEach(function(doc) {
    //       console.log(doc.id, " => ", doc.data());
    //       self.saved_notes.push(doc.data());
    //     });

    //     self.setState({
    //       notes: self.saved_notes,
    //       notes_fetching: false,
    //       timestamp:
    //         self.saved_notes.length > 0
    //           ? self.saved_notes[self.saved_notes.length - 1]["time"]
    //           : self.state.timestamp
    //     });
    //   });

    FetchData("/get_notes", {
      id: auth_token,
      skip_note: load_type === "load_recent" ? 0 : this.state.skip_note
    })
      .then(result => {
        console.log(result.length, result);

        if (result.length < 1) {
          this.setState({
            notes_fetching: false
          });
          return;
        }

        //self.saved_notes.push(result);
        result.map((value, index) => {
          saved_notes.push(value);
        });

        this.setState({
          //notes: result,
          notes: this.state.notes.concat(saved_notes),
          notes_fetching: false,
          skip_note: this.state.skip_note + result.length
        });
      })
      .catch(error => {
        this.setState({
          notes_fetching: false
        });
      });

    //realtime change
    // fbdb.collection("users").doc("bRt3oKyueSq1YCQPTHAe")
    // .onSnapshot(function(doc) {
    //     console.log("Current data: ", doc.data());
    // });
  };

  deleteNote = (note_key, _actions) => {
    //alert('delete' + note_key)
    const auth_token = localStorage.getItem("auth_token");

    FetchData("/delete_note", {
      id: auth_token,
      note_key: this.state.dialog_note_key // note_key
    })
      .then(result => {
        console.log(result, this.state.dialog_for_index);
        _actions.openSnackBar("Note deleted successfully.");

        let filteredItems = [];
        this.state.notes.map((value, index) => {
          console.log(value, index, this.state.dialog_for_index);
          if (index === this.state.dialog_for_index) {
            //alert(value[3] + " " + this.state.dialog_for_index)
          } else {
            filteredItems.push(value);
          }
        });
        this.setState({ notes: [] });
        this.setState({ notes: filteredItems });
      })
      .catch(error => {
        _actions.openSnackBar("Problem deleting. Please retry");
      });
  };

  saveNote = (note_key, note_text, _actions) => {
    //alert('delete' + note_key)
    const auth_token = localStorage.getItem("auth_token");

    FetchData("/save_note", {
      id: auth_token,
      note: this.state.dialog_note_text, //note_text,
      note_key: this.state.dialog_note_key // note_key
    })
      .then(result => {
        console.log(result);
        _actions.openSnackBar("Note resaved successfully.");
      })
      .catch(error => {
        _actions.openSnackBar("Problem saving. Please retry");
      });
  };

  render() {
    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <div>
            <div className="dividerMargin">
              <Divider />
            </div>

            <Button
              onClick={() => {
                this.setState({ skip_note: 0, notes: [] });
                this.getSavedNotes("load_recent");
              }}
              color="primary"
              size="small"
            >
              <NotesIcon style={{ marginRight: 10 }} />
              Recently saved notes
            </Button>

            <div className="dividerMargin">
              {/* loaded : {this.state.skip_note} */}
            </div>

            {this.state.notes.map((value, index) => {
              return (
                <div key={index}>
                  {/* <Typography>{value.note}</Typography> */}

                  {/* <textarea
                    className="noteClass"
                    value={value[0][3]}
                    onChange={e => {
                      let new_notes = this.state.notes;
                      new_notes[index][0][3] = e.target.value;
                      this.setState({ notes: new_notes });
                    }}
                  /> */}

                  {/* <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Placeholder"
                    multiline
                    margin="normal"
                    value={value[0][3]}
                    onChange={e => {
                      //console.log(e.currentTarget.value, index, this.state.notes);
                      let new_notes = this.state.notes;
                      new_notes[index][0][3] = e.target.value;
                      this.setState({ notes: new_notes });
                    }}
                  /> */}

                  <Grid container wrap="nowrap" spacing={0}>
                    <Grid item xs>
                      <InputBase
                        fullWidth
                        className="savedNote"
                        placeholder="Write note"
                        multiline
                        defaultValue={value[3]}
                        onChange={e => {
                          //console.log(e.currentTarget.value, index, this.state.notes);
                          let new_notes = this.state.notes;
                          new_notes[index][3] = e.target.value;
                          this.setState({ notes: new_notes });
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <IconButton
                        aria-label="menu"
                        onClick={() => {
                          this.setState({
                            dialog_id: value[1],
                            dialog_note_key: value[2],
                            dialog_note_text: value[3],
                            dialog_for_index: index,

                            dialogOpen: true
                          });
                        }}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                  </Grid>

                  {/* <Tooltip title="Save note" aria-label="Save" placement="top">
                    <IconButton
                      aria-label="Save"
                      onClick={() => {
                        this.saveNote(
                          this.state.notes[index][0][2],
                          this.state.notes[index][0][3],
                          actions
                        );
                      }}
                    >
                      <SaveIcon fontSize="small" />
                    </IconButton>
                  </Tooltip> */}

                  {/* <Tooltip
                    title="Delete note"
                    aria-label="Delete"
                    placement="top"
                  >
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        this.deleteNote(this.state.notes[index][2], actions);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip> */}

                  {/* <div className="dividerMargin">
                    <Divider />
                  </div> */}
                </div>
              );
            })}

            <div className="dividerMargin">
              {/* loaded : {this.state.skip_note} */}
            </div>

            {this.state.notes.length > 0 && (
              <div>
                <Button
                  onClick={() => {
                    this.getSavedNotes("load_more");
                  }}
                  size="small"
                  color="primary"
                >
                  <NotesIcon style={{ marginRight: 10 }} />
                  More notes
                </Button>
              </div>
            )}

            <div className="dividerMargin">
              {this.state.notes_fetching && <LinearProgress />}
              {/* <Divider /> */}
            </div>

            <Dialog
              open={this.state.dialogOpen}
              fullWidth
              onClose={() => {
                this.setState({ dialogOpen: false });
              }}
              aria-labelledby="simple-dialog-title"
            >
              <div>
                <List>
                  <ListItem
                    button
                    onClick={() => {
                      this.setState({ dialogOpen: false });
                      this.saveNote("", "", actions);
                    }}
                  >
                    <ListItemText primary="Resave note" />
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => {
                      this.deleteNote("", actions);
                      this.setState({ dialogOpen: false });
                    }}
                  >
                    <ListItemText primary="Delete note" />
                  </ListItem>
                </List>
              </div>
            </Dialog>

            {/* <Button
                      color={"primary"}
                      size="small"
                      onClick={() => {
                        this.setState({
                          words: [...this.state.words, ""]
                        });
                      }}
                    >
                      + more notes
                    </Button> */}

            <div className="dividerMargin" />
          </div>
        )}
      </AppContext.Consumer>
    );
  }
}

export default MyNotes;
